import { useNavigate } from 'react-router-dom';
import { signOut } from '../../auth';
import { useAuthStep } from '../../auth/context/AuthStepContext';

export const useLogout = () => {
  const navigate = useNavigate();
  const { resetStep } = useAuthStep();

  const logout = async () => {
    await signOut()
      .then(() => {
        navigate('/login');
      })
      .finally(() => {
        resetStep();
      });
  };

  return {
    logout,
  };
};
